import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-newsletter-signup',
  templateUrl: './ui-newsletter-signup.component.html',
  styleUrls: ['./ui-newsletter-signup.component.scss']
})
export class UiNewsletterSignupComponent {
  @Input() public isSubscribe: boolean;
  @Output() public onChange = new EventEmitter<boolean>();
}
